const doc = [({"en":({"js":({"admin":({"templates":({"create_card":({"create_template":"Create template"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;